import React, { useContext, useEffect, useMemo, useState } from "react";
import { Link, useNavigate } from 'react-router-dom';
import { Box, Button, CircularProgress, Grid, IconButton, } from "@mui/material";
import VisibilityIcon from '@mui/icons-material/Visibility';
import ModeEditOutlineOutlinedIcon from '@mui/icons-material/ModeEditOutlineOutlined';
import DeleteOutlineOutlinedIcon from '@mui/icons-material/DeleteOutlineOutlined';
import MessageBox from "../../components/common/CustomMessageBox";
import CustomDelete from '../../components/common/CustomDeleteAlert';
import CustomModal from "../../components/common/CustomModal";
import { ENQUIRY_COMPANY_DELETE, ENQUIRY_SUBSCRIPTION_EXPIRY_REMINDER, ENQUIRY_SUBSCRIPTION_LIST, } from "../../services/apiRoutes";
import axios from "axios";
import { AuthContext } from "../../context/AuthContext";
import CustomLoader from "../../components/common/CustomLoader";
import { ClearRounded, } from "@mui/icons-material";
import CustomButton from "../../components/common/CustomButton";
import CustomTextField from "../../components/common/CustomTextField";
import CustomFilter from "../../components/common/CustomFilter";
import FindReplaceOutlinedIcon from '@mui/icons-material/FindReplaceOutlined';
import { hasEditPermission, hasDeletePermission } from '../../services/CommonServices'
import { useLocation } from "react-router-dom";
import { genericPost } from "../../services/authServices";
import CustomDataTable from "../../components/common/CustomDataTable";

const title = 'Subscription List';

const EnquirySubscriptionList = () => {
    const { token } = useContext(AuthContext)
    const [modal, setModal] = useState(false);
    const [selectedId, setSelectedId] = useState(null); // State to hold selected ID
    const [clientCompanies, setClientCompanies] = useState([]);
    const [openDrawer, setOpenDrawer] = useState(false);
    const [message, setMessage] = useState({
        open: false,
        text: '',
        type: ''
    })
    const [rowId, setRowId] = useState('');
    const [loading, setLoading] = useState(false);
    const [error, setError] = useState(null);
    const [permission, setPermissions] = useState()
    const [page, setPage] = useState(0); // UI 0-based
    const [pageSize, setPageSize] = useState(10);
    const [rowCount, setRowCount] = useState(0);
    const [reminderLoadingId, setReminderLoadingId] = useState(null);


    const [filterPayload, setFilterPayload] = useState({
        fromDate: '',
        toDate: '',
        mobile: '',
        email: ''
    });
    const filterOpen = () => setOpenDrawer(true);
    const filterClose = () => setOpenDrawer(false);

    const navigate = useNavigate();

    const handleFilterChange = (field, value) => {
        setFilterPayload((prev) => ({
            ...prev,
            [field]: value || '',
        }));
    };
    const handleClearFilters = useMemo(() => {
        return () => {
            setFilterPayload({
                fromDate: '',
                toDate: '',
                mobile: '',
                email: ''
            });
            subscriptionData(0, pageSize, '');
        };
    }, [pageSize]);

    const location = useLocation();
    const currentPath = location.pathname;
    useEffect(() => {
        let rolePermisionsData = JSON.parse(sessionStorage.getItem('userData')) || []
        let editPermision = hasEditPermission(currentPath, rolePermisionsData?.permissions)
        let deletePermission = hasDeletePermission(currentPath, rolePermisionsData?.permissions)
        setPermissions({
            edit: editPermision,
            delete: deletePermission
        })
    }, [])

    const handleSendReminder = async (rowData) => {
        console.log("Selected Row Data:", rowData);
        setReminderLoadingId(rowData.id);
        const payload = {
            firstName: rowData.userName?.split(" ")[0] || "",
            email: rowData.email,
            companyName: rowData.clientCompanyName,
            subscriptionStartedOn: rowData.startDate,
            endDate: rowData.endDate,
            remainingDays: rowData.remaingDay,
            totalCompany: rowData.totalCompanies,
            totalUsers: rowData.totalUsers,
        };
        try {
            const accessToken = sessionStorage.getItem("accessToken");
            const response = await axios.post(
                ENQUIRY_SUBSCRIPTION_EXPIRY_REMINDER,
                payload,
                {
                    headers: {
                        "Content-Type": "application/json",
                        "Authorization": `Bearer ${accessToken}`
                    }
                }
            );
            // 🌟 turn off loader only when status = 201
            if (response.status === 201) {
                setReminderLoadingId(null);
                setMessage({
                    open: true,
                    text: "Reminder sent successfully!",
                    type: "success"
                });
            }
        } catch (error) {
            console.error(error);

            setReminderLoadingId(null); // stop loading
            setMessage({
                open: true,
                text: "Something went wrong",
                type: "error",
            });
        }
    };

    const columns = useMemo(
        () => [
            { accessorKey: "index", header: "SN.", size: 50, tableHeader: { alignItems: 'center', }, tableStyle: { textAlign: "center" }, enableColumnFilter: false },
            {
                accessorKey: "userName", header: "User Name", size: 100, enableSorting: true, tableHeader: {
                    justifyContent: 'flex-start',
                },
            },
            { accessorKey: "mobile", header: "Contact No.", size: 100, enableSorting: true, tableStyle: { textAlign: "center" }, },
            {
                accessorKey: "email", header: "Email ID", size: 100, enableSorting: true, tableHeader: {
                    justifyContent: 'flex-start',
                },
            },
            {
                accessorKey: "clientCompanyName", header: "Company", size: 100, enableSorting: true, tableHeader: {
                    justifyContent: 'flex-start',
                },
            },
            {
                accessorKey: "subscriptionPlan",
                header: "Subscription Plan",
                size: 100,
                tableHeader: { justifyContent: 'flex-start' },
                enableSorting: true
            },
            {
                accessorKey: "totalUsers",
                header: "Total Users",
                size: 50,
                tableStyle: { textAlign: "center" },
                enableSorting: true
            },
            {
                accessorKey: "totalCompanies",
                header: "Total Company",
                size: 50,
                tableStyle: { textAlign: "center" },
                enableSorting: true
            },
            {
                accessorKey: "startDate",
                header: "Start Date",
                size: 50,
                tableStyle: { textAlign: "center" },
                enableSorting: true
            },
            {
                accessorKey: "endDate",
                header: "End Date",
                size: 50,
                tableStyle: { textAlign: "center" },
                enableSorting: true
            },
            {
                accessorKey: "remaingDay",
                header: "remaing Day",
                size: 50,
                tableStyle: { textAlign: "center" },
                enableSorting: true
            },
            {
                accessorKey: "amountPaid",
                header: "Amount Paid",
                size: 50,
                tableStyle: { textAlign: "center" },
                enableSorting: true
            },

            {
                accessorKey: "razorpayPaymentId",
                header: "Razorpay Payment ID",
                size: 100,
                tableHeader: { justifyContent: 'flex-start' },
                enableSorting: true
            },
            {
                accessorKey: "status",
                header: "Status",
                size: 50,
                tableStyle: { textAlign: "center" },
                enableSorting: true
            },

            {
                accessorKey: "action",
                header: "Action",
                size: 50,
                enableSorting: false,
                Cell: ({ row }) => (
                    <>
                        <div style={{ display: 'flex', justifyContent: 'center', alignItems: 'center', gap: '1px' }}>
                            <Button
                                variant="outlined"
                                onClick={() => handleSendReminder(row.original)}
                                disabled={reminderLoadingId === row.original.id}
                                sx={{
                                    color: '#007BFF',
                                    borderColor: '#007BFF',
                                    fontWeight: 100,
                                    textAlign: 'center',
                                    cursor: 'pointer',
                                    width: "100px",
                                    height: "32px",
                                    fontSize: "12px",
                                    textTransform: "capitalize",
                                    position: "relative",
                                }}
                            >
                                {reminderLoadingId === row.original.id ? (
                                    <CircularProgress size={18} sx={{ color: "#007BFF" }} />
                                ) : ("Reminder")}

                            </Button>

                        </div>
                    </>
                ),
            },
        ],
        [permission, reminderLoadingId]
    );
    const calculateRemainingDaysFromToday = (end) => {
        if (!end) return "";

        const today = new Date();                     // today
        const endDate = new Date(end);               // subscription end date

        // Clear time part to avoid timezone issues
        today.setHours(0, 0, 0, 0);
        endDate.setHours(0, 0, 0, 0);

        const diffTime = endDate - today;            // milliseconds difference
        const diffDays = Math.ceil(diffTime / (1000 * 60 * 60 * 24));

        return diffDays >= 0 ? diffDays : 0;         // if negative, show 0
    };

    const subscriptionData = async (pageIndex = 0, pageSize = 10) => {
        setLoading(true);
        try {
            const payload = {
                page: pageIndex + 1,
                limit: pageSize,
                ...filterPayload
            };
            const response = await genericPost(ENQUIRY_SUBSCRIPTION_LIST, payload, {});
            if (response.data.success && response.data.enquirySubscriptionList) {
                const subscriptionData = response.data.enquirySubscriptionList.map((item, index) => ({
                    index: (index + 1).toString().padStart(2, '0'),
                    id: item.id || '',
                    clientCompanyName: item.company?.companyName || '',
                    mobile: item?.company?.user?.mobile || '',
                    email: item?.company?.user?.email || '',
                    userName: `${item?.company?.user?.firstName || ''} ${item?.company?.user?.lastName || ''}`.trim(),
                    companyAdmin: '',
                    subscriptionPlan: item?.SubscriptionBuy?.PlanType?.planName || '',
                    totalUsers: item.totalUsers || 0,
                    totalCompanies: item.totalCompany || 0,
                    endDate: item.endDate || '',
                    startDate: item.subscriptionStartedOn || '',
                    amountPaid: `${item?.SubscriptionBuy?.currencyList?.currency_symbol || ''}${Number(item?.SubscriptionBuy?.totalPrice || 0).toFixed(2)}`,

                    razorpayPaymentId: item?.SubscriptionBuy?.razorpayPaymentId || '',
                    status: item?.SubscriptionBuy?.razorpayPaymentId ? 'Paid' : 'Pending',
                    remaingDay: calculateRemainingDaysFromToday(item.endDate),
                }));

                setClientCompanies(subscriptionData);
                setRowCount(response.data.pagination?.totalRecords || 0);

            } else {
                setError('No subscription records found');
            }
        } catch (error) {
            console.error('Error fetching subscriptions:', error);
            setError('Error fetching subscription data');
        } finally {
            setLoading(false);
        }
    };

    const handleOpen = () => {
        setModal(true);
    };

    useEffect(() => {
        subscriptionData(page, pageSize,)
    }, [page, pageSize, token,])

    return (
        <>
            <Box sx={{ padding: '10px' }}>
                <CustomLoader open={loading} />
                <CustomDataTable
                    title={title}
                    columns={columns}
                    data={clientCompanies}
                    handleFilterButton={filterOpen}
                    fiterButtonTitile="Fiter"
                    rowCount={rowCount}
                    page={page}
                    setPage={setPage}
                    pageSize={pageSize}
                    setPageSize={setPageSize}
                    fromDate={filterPayload.fromDate || ""}
                    toDate={filterPayload.toDate || ""}
                />
                <MessageBox
                    open={message.open}
                    onClose={() => setMessage({ ...message, open: false })}
                    message={message.text}
                    handleClose={() => setMessage({ ...message, open: false })}
                    type={message.type}
                />
                <CustomFilter
                    drawerTitle="Filter Options"
                    drawerWidth={300}
                    openDrawer={openDrawer}
                    onClose={filterClose}
                    drawerContent={
                        <>
                            <Box>
                                <Grid container spacing={1} sx={{ padding: 0, }}>

                                    <Grid item xs={12}>
                                        <CustomTextField
                                            placeholder="Mobile"
                                            type="number"
                                            value={filterPayload.mobile}
                                            onChange={(e) => handleFilterChange('mobile', e.target.value)}
                                        />
                                    </Grid>
                                    <Grid item xs={12}>
                                        <CustomTextField
                                            placeholder="Email"
                                            type="text"
                                            value={filterPayload.email}
                                            onChange={(e) => handleFilterChange('email', e.target.value)}
                                        />
                                    </Grid>

                                    <Grid item xs={12} sm={12} md={12}>
                                        <CustomTextField
                                            fieldLabel="from Date"
                                            type="date"
                                            value={filterPayload.fromDate}
                                            onChange={(e) => handleFilterChange('fromDate', e.target.value)}
                                            placeholder="From Date"
                                        />
                                    </Grid>
                                    <Grid item xs={12} sm={12} md={12}>
                                        <CustomTextField
                                            fieldLabel="to Date"
                                            type="date"
                                            value={filterPayload.toDate}
                                            onChange={(e) => handleFilterChange('toDate', e.target.value)}
                                            placeholder="To Date"
                                        />
                                    </Grid>
                                    <Grid item xs={12} sm={12} md={12} sx={{ display: 'flex', alignItems: 'center', marginTop: "10px" }}>

                                        <CustomButton
                                            startIcon={<FindReplaceOutlinedIcon />}
                                            title="Apply"
                                            size="small"
                                            variant="contained"
                                            onClick={subscriptionData}
                                        />
                                        <CustomButton
                                            variant="outlined"
                                            title="Clear"
                                            startIcon={<ClearRounded />}
                                            style={cif_fob_style}
                                            onClick={handleClearFilters}
                                        />

                                    </Grid>
                                </Grid>
                            </Box>
                        </>
                    }
                />

            </Box>
        </>
    );
};

export default EnquirySubscriptionList;

const cif_fob_style = {
    backgroundColor: '#ffff',
    color: '#007bff',
    textTransform: "capitalize",
    borderRadius: 4,
    border: '1px solid #007bff',
    height: 30,
    display: 'inline-flex',
    alignItems: 'center',
    justifyContent: 'center',
    width: "100px"

}
